import UploadMore from './UploadMore';
import UploadMoreContainer from './UploadMore.container';

export default UploadMoreContainer(UploadMore);
